// src/hooks/useMediaQuery.js
import { useState, useEffect } from 'react';

/**
 * Hook personalizzato per gestire le media query per il responsive design
 * @param {string} query - La media query CSS da valutare (es. '(max-width: 768px)')
 * @returns {boolean} - True se la media query corrisponde, altrimenti False
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // Verifica se window è disponibile (per evitare errori in SSR)
    if (typeof window === 'undefined') {
      return;
    }
    
    // Crea il media query listener
    const media = window.matchMedia(query);
    
    // Imposta il valore iniziale
    setMatches(media.matches);
    
    // Callback da eseguire quando la media query cambia
    const listener = (event) => {
      setMatches(event.matches);
    };
    
    // Aggiungi il listener
    // Controlla se il browser supporta addEventListener o l'API più vecchia
    if (media.addEventListener) {
      media.addEventListener('change', listener);
    } else {
      media.addListener(listener); // Per browser più vecchi
    }
    
    // Cleanup al dismount
    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', listener);
      } else {
        media.removeListener(listener); // Per browser più vecchi
      }
    };
  }, [query]);

  return matches;
}

export default useMediaQuery;